import { render, staticRenderFns } from "./MonthlyEPFSubmissionRecordGrid.vue?vue&type=template&id=45b35fe4"
import script from "./MonthlyEPFSubmissionRecordGrid.vue?vue&type=script&lang=js"
export * from "./MonthlyEPFSubmissionRecordGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports